import { create } from 'zustand';

interface FakeParticipantsState {
  count: number;
  generatedIds: string[];
  apply: (count: number) => void;
  clear: () => void;
}

export const useFakeParticipantsStore = create<FakeParticipantsState>(
  (set) => ({
    count: 0,
    generatedIds: [],
    apply: (count: number) => {
      const ids = Array.from({ length: count }, () => `fake__${crypto.randomUUID()}`);
      set({ count, generatedIds: ids });
    },
    clear: () => set({ count: 0, generatedIds: [] }),
  }),
);
